import { GESTION_PRODUCTOS_TYPES } from "../constants/gestionProducto.types";
import { Productos, ProductosAction, ProductosState } from "../interfaces/productos.interface";
//import { Productos, ProductosAction, ProductosState } from "../interfaces/productos.interface";

const initialState: ProductosState = {
    productosData:[],
    productosFormCargar:{},
    productosFileDataCargada:{},
    productosActivos:{}
}

const productosReducer = (
    state: Productos = initialState,
    action: ProductosAction
): ProductosState =>{
    switch(action.type){
    case GESTION_PRODUCTOS_TYPES.PRODUCTOS_CHANGE_FORM_CARGA:
        return{...state, productosFormCargar: action.payload}
    case GESTION_PRODUCTOS_TYPES.PRODUCTOS_SET_FILE_DATA_CARGADA:
        return{...state, productosFileDataCargada: action.payload}
    case GESTION_PRODUCTOS_TYPES.PRODUCTOS_SET_PRODUCTO_ACTIVO:
        return{...state, productosActivos: action.payload}
    case GESTION_PRODUCTOS_TYPES.PRODUCTOS_SET_DATA_PRODUCTO:
        return{...state, productosData: action.payload}
    case GESTION_PRODUCTOS_TYPES.PRODUCTOS_CLEAR:
        return{ ...initialState}
        default:
            return state
    }
}
export default productosReducer